// extracted by mini-css-extract-plugin
export var iconBig = "icons-module--iconBig--5f836";
export var icons = "icons-module--icons--5ee7a";